import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Link } from "react-router-dom";
import { List } from "antd";
import { HEAD_DEFAULT, IMG_DEFAULT } from "../../common/baseConfig";
import moment from "moment";
import NoneData from "../common/NoneData";
export class CourseManageMyComment extends Component {
  state = {
    curPage: 1,
  }
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    this.onLoadMyComments();
  }
  onLoadMyComments() {
    this.props.actions.fetchGetMyComment({
      PageSize: 5,
      PageIndex: this.state.curPage,
      PageStatus: 1,
      Valid: 1,
    })
  }
  renderItem(item, key) {
    return (
      <div key={key} className="my-comment-list-item">
        <div className="comment-content">
          <img src={item.HeadImg || HEAD_DEFAULT} alt="" />
          <h1>
            <p>
              <span>{item.StuName}</span><span>{moment(new Date(item.AddTime)).format("YYYY-MM-DD HH:mm:ss")}</span>
            </p>
            <p>
              {item.Content}
            </p>
          </h1>
        </div>
        <Link to={`/course/detail/${item.ID}`}>
          <div className="course-content">
            <div>
              <img src={item.CoverPath || IMG_DEFAULT} alt="" />
              <h2>
                <p>{item.CourseName}</p>
                <p>授课老师：{item.TeacherName || "匿名"}</p>
              </h2>
            </div>
            <p>¥{item.PreferentialPrice.toFixed(2)}</p>
          </div>
        </Link>
      </div>
    )
  }
  render() {
    const { fetchGetMyCommentSuccess, fetchGetMyCommentTotal, fetchGetMyCommentPending } = this.props.center;

    return (
      <div className="center-course-manage-my-comment">
        {
          fetchGetMyCommentSuccess && fetchGetMyCommentSuccess.length > 0 &&
          <div className="my-comment-list">
            <List
              itemLayout="horizontal"
              size="large"
              pagination={{
                onChange: page => {
                  this.setState({
                    curPage: page,
                  }, () => {
                    this.onLoadMyComments();
                  })
                },
                current: this.state.curPage,
                total: fetchGetMyCommentTotal,
                pageSize: 5,
              }}
              loading={fetchGetMyCommentPending}
              dataSource={fetchGetMyCommentSuccess}
              renderItem={(item, key) => this.renderItem(item, key)}
            />
          </div>
        }
        {
          fetchGetMyCommentSuccess && fetchGetMyCommentSuccess.length === 0 && <div className="noneData">
            <NoneData type={2} />
          </div>
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseManageMyComment);



// WEBPACK FOOTER //
// ./src/features/center/CourseManageMyComment.js